module.exports = __webpack_public_path__ + "src/assets/images/logos//paxia-cloud-logo-2025.svg";